





import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
} from "vant";
import WeMixin from "@/components/weMixin";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";

import XsyxHomeFa from "./XsyxHomeFa.vue";
import UserInfo from "../user/UserInfo.vue";

import md5 from "js-md5";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
    XsyxHomeFa,
    UserInfo,
  },
})
export default class BeforeHome extends mixins(WeMixin) {
  protected created() {
    const productid = "product_9223372036854775807";
    const subopenid = "123";
    const notifyurl = encodeURIComponent(
      process.env.VUE_APP_URLFRONT + "/main/home/xsyxhome"
    );
    const key = "003E0A6183B5423591CEE53F4585ABC4";
    const test =
      "notify_url=" +
      notifyurl +
      "&product_id=" +
      productid +
      "&sub_openid=" +
      subopenid +
      "&key=" +
      key;
    console.log("md5前:" + test);
    const test1 = md5(
      "notify_url=" +
        notifyurl +
        "&product_id=" +
        productid +
        "&sub_openid=" +
        subopenid +
        "&key=" +
        key
    );
    console.log("md5后:" + test1);
    const sign = md5(
      "notify_url=" +
        notifyurl +
        "&product_id=" +
        productid +
        "&sub_openid=" +
        subopenid +
        "&key=" +
        key
    ).toUpperCase();
    window.location.href =
      "https://pay.gdwxyf.com/pay/scene/h5bindopenidTominiapp.html?" +
      "product_id=" +
      productid +
      "&sign=" +
      sign +
      "&sub_openid=" +
      subopenid +
      "&notify_url=" +
      notifyurl;
  }
}
